import { LoadingIcon } from "@/assets/svg/LoadingIcon";

export default function Loading() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/30 backdrop-blur-lg">
      <div className="flex flex-col items-center">
        <LoadingIcon />
        <p className="mt-4 text-gray-700 font-medium">Loading...</p>
      </div>
    </div>
  );
}
